export function Spinner() {
  return (
    <svg className="animate-spin h-8 w-8 mr-4" viewBox="0 0 30 30">
      <circle
        className="path"
        cx="15"
        cy="15"
        r="13"
        fill="none"
        stroke="#5652bf"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="1, 150"
        strokeDashoffset="0"
      />
    </svg>
  );
}
